import {isAxiosError} from 'axios';
import type {AxiosInstance, AxiosResponse} from 'axios';
import type ErgAuthService from '@ergeon/erg-auth';

const HTTP_UNAUTHORIZED = 401;

export const hasLiveSession = (authService: ErgAuthService): boolean => {
  const payload = authService.getPayload(authService.getToken());
  if (!payload) {
    return false;
  }

  return !authService.isExpired(payload);
};

const isUnauthorized = (response?: AxiosResponse): boolean => response?.status === HTTP_UNAUTHORIZED;

export const watchUnauthorizedResponses = (client: AxiosInstance, onUnauthorized: () => void): (() => void) => {
  const interceptorId = client.interceptors.response.use(
    (response) => {
      if (isUnauthorized(response)) {
        onUnauthorized();
      }
      return response;
    },
    (error: unknown) => {
      if (isAxiosError(error) && isUnauthorized(error.response)) {
        onUnauthorized();
      }
      return Promise.reject(error);
    },
  );

  return () => client.interceptors.response.eject(interceptorId);
};
